export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const SITE_URL = process.env.NEXT_PUBLIC_URL;

export const USER_CONSENT_COOKIE_KEY: string = 'user_accepted_cookies';
